// Built-ins
import { useState, useEffect } from "react";

// CSS
import "react-phone-number-input/style.css";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";
import { BsInfoSquare } from "react-icons/bs";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";

// Modules / Functions
import axios from "axios";
import Swal from "sweetalert2";
import { Modal, Col, Form, Row } from "react-bootstrap";
import { Button } from "semantic-ui-react";
import PhoneInput from "react-phone-input-2";

// Global Variables
import { headers } from "../global_vars";

// Variables
window.Swal = Swal;

let warningStyle = {
  fontSize: 18,
  marginRight: 6,
};

let checkStyle = {
  fontSize: 18,
  marginRight: 6,
};

const EDIT_CONTACT_PERSON =
  "https://groupplan.gr/api/data_management/edit_contact_person/";

let formControlStyle = {
  marginBottom: 10,
  width: "93%",
  display: "inline-block",
};

const allowAlpha = (value) => {
  return value.replace(/[^\w\s.\-/&\u4e00-\u9eff]{1,20}$/g, "");
};

function EditContactPersonModal(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [Name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [position, setPosition] = useState("");
  const [tel, setTel] = useState("");

  useEffect(() => {
    if (show && props.person) {
      setName(props.person.name || "");
      setEmail(props.person.email || "");
      setPosition(props.person.position || "");
      setTel(props.person.tel || "");
    }
  }, [show, props.person]);

  const editContactPerson = () => {
    axios({
      method: "post",
      url: EDIT_CONTACT_PERSON + props.object_id,
      headers: headers,
      data: {
        object_id: props.object_id,
        object_type: props.object_type,
        contact_person_id: props.person.id,
        name: Name,
        email: email,
        position: position,
        tel: tel,
      },
    })
      .then((res) => {
        props.add_contact_person(res.data.contact_persons);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response?.data?.errormsg || "An unknown error has occurred.",
        });
      });
  };

  return (
    <>
      <FiEdit2
        id="edit_contact_person_icon"
        title="Edit Contact Person"
        onClick={handleShow}
        className={"edit_icon"}
      />
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        aria-labelledby="edit-contact-person-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Contact Person — {props.object_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Name:
            </Form.Label>
            <Col sm="10">
              <Form.Control
                maxLength="50"
                onChange={(e) =>
                  setName(allowAlpha(e.currentTarget.value.toUpperCase()))
                }
                style={formControlStyle}
                value={Name}
              />
            </Col>
            <Form.Label column sm="2">
              Tel
            </Form.Label>
            <Col sm="10">
              <PhoneInput
                international
                maxLength={20}
                defaultCountry="GR"
                countryCallingCodeEditable={false}
                value={tel}
                style={{ width: 590, marginBottom: 10 }}
                onChange={setTel}
              />
            </Col>
            <Form.Label column sm="2">
              Email
            </Form.Label>
            <Col sm="10">
              <Form.Control
                style={formControlStyle}
                maxLength="100"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                value={email}
              />
            </Col>
            <Form.Label column sm="2">
              Position
            </Form.Label>
            <Col sm="10">
              <Form.Control
                style={formControlStyle}
                maxLength="255"
                onChange={(e) => {
                  setPosition(e.target.value);
                }}
                value={position}
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            Name must be at least 3 characters.
            {Name.length < 3 ? (
              <ul
                className="mr-auto"
                style={{ margin: 0, padding: 0, marginTop: 10, color: "red" }}
              >
                <li>
                  {Name.length < 3 ? (
                    <>
                      {" "}
                      <AiOutlineWarning style={warningStyle} /> Fill The Name
                      Field.
                    </>
                  ) : (
                    ""
                  )}
                </li>
              </ul>
            ) : (
              <ul
                className="mr-auto"
                style={{ margin: 0, padding: 0, marginTop: 10, color: "green" }}
              >
                <li>
                  <AiOutlineCheckCircle style={checkStyle} /> Validated
                </li>
              </ul>
            )}
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              editContactPerson();
            }}
            disabled={Name.length < 3}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditContactPersonModal;
